
const isFacebookApp = () => {
    var ua = navigator.userAgent || navigator.vendor || window.opera;
    return (ua.indexOf("FBAN") > -1) || (ua.indexOf("FBAV") > -1);
}

// https://topic.alibabacloud.com/a/how-to-determine-the-built-in-wechat-browser-implemented-through-user-agent-and-useragent_1_24_32605959.html
const isWeChat = () => {
    var ua = navigator.userAgent.toLowerCase()
    if(ua.match(/MicroMessenger/i)=="micromessenger") {
        return true;
    } else {
        return false;
    }
}
const signInOptions = () => {
    const phoneLogin = {
        provider: firebase.auth.PhoneAuthProvider.PROVIDER_ID,
        recaptchaParameters: {
            type: 'image', // 'audio'
            size: 'invisible', // 'normal', 'invisible' or 'compact'
            badge: 'bottomleft' //' bottomright' or 'inline' applies to invisible.
        },
        defaultCountry: 'MY', // Set default country to the United Kingdom (+44).
        // For prefilling the national number, set defaultNationNumber.
        // This will only be observed if only phone Auth provider is used since
        // for multiple providers, the NASCAR screen will always render first
        // with a 'sign in with phone number' button.
        defaultNationalNumber: '',
        // You can also pass the full phone number string instead of the
        // 'defaultCountry' and 'defaultNationalNumber'. However, in this case,
        // the first country ID that matches the country code will be used to
        // populate the country selector. So for countries that share the same
        // country code, the selected country may not be the expected one.
        // In that case, pass the 'defaultCountry' instead to ensure the exact
        // country is selected. The 'defaultCountry' and 'defaultNationaNumber'
        // will always have higher priority than 'loginHint' which will be ignored
        // in their favor. In this case, the default country will be 'GB' even
        // though 'loginHint' specified the country code as '+1'.
        loginHint: ''
    }
    if (isWeChat()) {
        return [
            phoneLogin
        ]
    }
    else {

        let loginMethods = [
            {
                provider: firebase.auth.GoogleAuthProvider.PROVIDER_ID,
                scopes: [
                    'profile',
                    'email',
                ],
            },
        ]

        if (!window.disableFbLogin) {
            loginMethods.push({
                provider: firebase.auth.FacebookAuthProvider.PROVIDER_ID,
                scopes: [
                    'public_profile',
                    'email',
                ],
            })
        }
        loginMethods.push(phoneLogin)
        return loginMethods
    }
}
export default function getFirebaseUIConfig(signInSuccessWithAuthResult) {
    return {
        // Popup signin flow rather than redirect flow.
        signInFlow: isFacebookApp() ? 'redirect' : 'popup',

        // Redirect to /signedIn after sign in is successful. Alternatively you can provide a callbacks.signInSuccess function.
        callbacks: {
            // Avoid redirects after sign-in.
            signInSuccessWithAuthResult: (authResult, redirectUrl) => signInSuccessWithAuthResult(authResult, redirectUrl),
        },
        // We will display Google and Facebook as auth providers.
        signInOptions: signInOptions(),
    }
}